import React, { useState } from "react";
import { useFetchData } from 'services/queries';
import Box from '@mui/material/Box';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import { Link } from "react-router-dom";
import { BsPencilSquare, BsTrash, BsFillEyeFill } from "react-icons/bs";
import { GridActionsCellItem } from '@mui/x-data-grid';
import useRoleBasedColumns from 'hooks/useRoleBasedColumns';
import DeleteConfirmDialog from 'components/dialog/DeleteConfirmDialog';
import ToolbarCrud from 'components/toolbar/ToolbarCrud';
import { CATEGORY_CHOICES } from 'constants';

const SubcategoriesTab = () => {
  const resource = 'additional-cost/subcategory';
  const resource_name = 'Subcategory';
  const { data: data, error: errorData, isLoading: isLoadingData } = useFetchData(
    resource,
    true
  );
  
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  // Convert CATEGORY_CHOICES array to object for easy lookup
  const categoryDisplay = CATEGORY_CHOICES.reduce((acc, choice) => {
    acc[choice.value] = choice.label;
    return acc;
  }, {});

  const columnsData = [
    {
      field: 'category',
      headerName: 'Category',
      width: 200,
      editable: false,
      groupable: true,
      type: 'string',
      renderCell: (params) => {
        if (!params.row) return '';
        // Use category_display from backend if available, otherwise use local mapping
        return params.row.category_display || categoryDisplay[params.row.category] || params.row.category;
      },
    },
    {
      field: 'name',
      headerName: 'Subcategory Name',
      width: 250,
      editable: false,
      groupable: false,
      type: 'string',
    },
    {
      field: 'description',
      headerName: 'Description',
      width: 350,
      editable: false,
      groupable: false,
      type: 'string',
    },
    {
      field: 'actions',
      headerName: 'Actions',
      type: 'actions',
      width: 120,
      editable: false,
      groupable: false,
      aggregable: false,
      visibleTo: ['Administrator'],
      getActions: (params) => {
        const { id } = params.row;
        return [
          <GridActionsCellItem
            icon={<BsFillEyeFill />}
            color="primary"
            label="View"
            component={Link}
            to={`/admin/settings/additional-costs/view/${id}`}
          />,
          <GridActionsCellItem
            icon={<BsPencilSquare />}
            color="primary"
            label="Edit"
            component={Link}
            to={`/admin/settings/additional-costs/edit/${id}`}
          />,
          <GridActionsCellItem
            color="primary"
            icon={<BsTrash />}
            label="Delete"
            onClick={() => {
              setSelectedItem(params.row.id);
              setOpenDeleteDialog(true);
            }}
          />,
        ];
      }
    },
  ];
  
  const columns = useRoleBasedColumns(columnsData);

  if (isLoadingData) return <div>Loading...</div>;
  if (errorData) return <div>Error! {errorData?.message || 'Failed to load subcategories'}</div>;

  return (
    <>
      <Box>
        <DataGridPremium
          rows={data || []}
          columns={columns.map(column => ({
            ...column,
            editable: false
          }))}
          initialState={{
            pinnedColumns: { left: ['actions'] },
            density: 'comfortable',
            sorting: {
              sortModel: [{ field: 'category', sort: 'asc' }],
            },
          }}
          slots={{
            toolbar: () => <ToolbarCrud
              resource="settings/additional-costs"
              name={resource_name} />
          }}
        />
      </Box>
      <DeleteConfirmDialog
        openDeleteDialog={openDeleteDialog}
        setOpenDeleteDialog={setOpenDeleteDialog}
        selectedItem={selectedItem}
        resource={resource}
      />
    </>
  );
};

export default SubcategoriesTab;